<template>
  <div class="flex items-center">
    <vs-input
      style="width:300px"
      placeholder="Notunuzu Girin.."
      v-model="message"
    />
    <vs-button type="filled" size="small" class="ml-3" @click="addNewMessage">Not Ekle</vs-button>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";

export default {
  props: {
    customerId:{
    required: true,
    }
  },
  data() {
    return {
      message: "",
    };
  },
  methods: {
    addNewMessage: async function () {
      if (this.customerId > 0) {
        let a = await repository.postEntity("Customer/addNote", {
          id: this.customerId,
          value: this.message,
        });
        if (a && a.isSuccessful) {
          this.$vs.notify({
            title: "Başarılı",
            text: "Mesajınız eklendi",
            color: "success",
            icon: "done",
          });
          this.$emit("completed", {response: true, data: { message: this.message, createdDate: navigator.getDate() , user: this.$store.state.userData.userName }});
          this.message = "";
          return;

        }
      }
      this.$vs.notify({
        title: "Hata",
        text: "Mesajınız eklenemedi",
        color: "danger",
        icon: "warning",
      });

      this.$emit("completed", false);
    },
  },
};
</script>